module.exports = "/lucky-balls/img/bigball/BigBall_002.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bigball/BigBall_002.png
// module id = 897
// module chunks = 0